import { WHY_CHOOSE_US } from "@/lib/data";

export default function WhyChooseUs() {
  return (
    <section id="about" data-testid="why-section" className="py-24 lg:py-32 bg-[#FDFBFA] relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <span className="eyebrow">Why DDigital</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
            A partner that takes your growth <em className="italic font-medium">personally</em>.
          </h2>
          <p className="mt-6 text-lg text-[#475569] leading-relaxed">
            We don’t treat marketing like a service line — we treat it like ownership.
            Every campaign, every report, every call is built around the question that matters: <span className="text-[#041047] font-semibold">is this making the client money?</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#041047]/10">
          {WHY_CHOOSE_US.map((w, i) => (
            <div
              key={w.title}
              data-testid={`why-card-${i}`}
              className="bg-white p-8 md:p-10 group hover:bg-[#FDFBFA] transition-colors"
            >
              <div className="flex items-start gap-4 mb-4">
                <span className="font-display text-3xl text-[#D4AF37]">{w.num}</span>
                <div className="h-px flex-1 bg-[#041047]/15 mt-5" />
              </div>
              <h3 className="font-display text-xl md:text-2xl text-[#041047] mb-3">{w.title}</h3>
              <p className="text-[#475569] leading-relaxed text-[0.95rem]">{w.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
